import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { IVenueListItem } from '@core/interfaces/venue/venue-list-item.interface';
import { IVenueSource } from '@core/interfaces/venue/venue-source.interface';
import { ListResult } from '@core/models/list-result/list-result.model';
import { SearchParams } from '@core/models/query-params/search-params.model';
import { VenueListItem } from '@core/models/venue/venue-list-item.model';
import { ApiError } from '@interticket/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ICityInfo } from '../../interfaces/venue/city-info.interface';
import { CityInfo } from '../../models/venue/city-info.model';

@Injectable()
export class VenueService {

  constructor(
    private venueSourceService: IVenueSource
  ) { }

  getList(searchParams?: SearchParams): Observable<ListResult<IVenueListItem, VenueListItem>> {
    return this.venueSourceService.getList(searchParams)
      .pipe(
        take(1),
        map((iListResult: IListResult<IVenueListItem>) => new ListResult<IVenueListItem, VenueListItem>(iListResult, VenueListItem))
      );
  }

  getCityByZipCode(zipCode: string): Observable<CityInfo> {
    return this.venueSourceService.getCityByZipCode(zipCode)
      .pipe(
        take(1),
        map((iCityInfo: ICityInfo) => new CityInfo(iCityInfo)),
        catchError((error: ApiError) => error instanceof HttpErrorResponse && error.status === HttpStatusCode.NotFound ? of(null) : throwError(error))
      );
  }

}
